export default {
  path: "/",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  meta: {
    // requiresAuth: true
  },
  redirect: () => {
    // the function receives the target route as the argument
    // a relative location doesn't start with `/`
    // or { path: 'profile'}
    return "home";
  },
  components: {
    default: () =>
      import(
        /* webpackChunkName: "AppLayout" */ "../components/Layout/AppLayout.vue"
      ),
    // default: () => import(/* webpackChunkName: "Home" */ '../pages/Welcome.vue'),
    // default: () => import(/* webpackChunkName: "AppLayout" */ '../components/Layout/AppLayout.vue'),
  },
  children: [
    {
      path: "/ecotableware",
      meta: {
        requiresAuth: false,
      },
      component: () =>
        import(/* webpackChunkName: "Service" */ "../pages/Ecotableware.vue"),
    },
    {
      path: "/scanalert",
      meta: {
        requiresAuth: false,
        pwaCheck: true,
      },
      component: () =>
        import(/* webpackChunkName: "Service" */ "../pages/ScanAlert.vue"),
    },
    {
      path: "/welcome",
      meta: {
        requiresAuth: false,
        pwaCheck: true,
      },
      component: () =>
        import(/* webpackChunkName: "Service" */ "../pages/Welcome.vue"),
    },
    {
      path: "/polices/privacy",
      meta: {
        requiresAuth: false,
        pwaCheck: true,
      },
      component: () =>
        import( "../pages/Polices/Privacy.vue"),
    },
    {
      path: "/guest",
      meta: {
        requiresAuth: false,
        mode: "guest",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Home" */ "../pages/Guest.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        // NotificationBar: () => import(/* webpackChunkName: "NotificationBar" */ '../components/Layout/NotificationBar.vue'),
      },
    },
    {
      path: "/guest/articles/:id",
      meta: {
        requiresAuth: false,
        mode: "guest",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Article" */ "../pages/Article.vue"),
      },
    },
    {
      path: "/limited-time-mission-detail",
      meta: {
        requiresAuth: false,
      },
      component: () =>
        import(/* webpackChunkName: "LimitedTimeMissionDetail" */ "../pages/LimitedTimeMissionDetail.vue"),
    },
    {
      path: "/home",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Home" */ "../pages/Home.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/service",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Service" */ "../pages/Service.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/service/on-site-activities",
      meta: {
        requiresAuth: true,
        publisher: "municipal",
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ActiveQuestions" */ "../pages/ActiveQuestions.vue"
          ),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/service/questions",
      meta: {
        requiresAuth: false,
        publisher: "municipal",
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ActiveQuestions" */ "../pages/ActiveQuestions.vue"
          ),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/service/survey/:status",
      meta: {
        requiresAuth: true,
        publisher: "municipal",
        campaignType: "questionnaire",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Survey" */ "../pages/Survey.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/service/e-voting/:status",
      meta: {
        requiresAuth: true,
        publisher: "municipal",
        campaignType: "vote",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Survey" */ "../pages/Survey.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/service/question-detail/:id",
      meta: {
        requiresAuth: false,
        publisher: "municipal",
      },
      components: {
        default: () => import(/* webpackChunkName: "QA" */ "../pages/QADetail.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/service/qa/:id",
      meta: {
        requiresAuth: false,
        publisher: "municipal",
      },
      components: {
        default: () => import(/* webpackChunkName: "QA" */ "../pages/QA.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/service/qre/:id",
      meta: {
        requiresAuth: true,
        publisher: "municipal",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "QA" */ "../pages/Questionnaire.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/service/check-in/:id",
      meta: {
        requiresAuth: true,
        publisher: "municipal",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "CheckIn" */ "../pages/CheckIn.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/scanner",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Scanner" */ "../pages/Scanner.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/profile",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Profile" */ "../pages/Profile.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/ddwallet-agreement",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "DDwalletAgreement" */ "../pages/DDwalletAgreement.vue")
      },
    },
    {
      path: "/map",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "AppointStoreMap" */ "../pages/AppointStoreMap.vue"
          ),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/record",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Record" */ "../pages/Record.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
        NotificationBar: () =>
          import(
            /* webpackChunkName: "NotificationBar" */ "../components/Layout/NotificationBar.vue"
          ),
      },
    },
    {
      path: "/qa/:id",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () => import(/* webpackChunkName: "QA" */ "../pages/QA.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/appoint-store",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "AppointStore" */ "../pages/AppointStore.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/barcode",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Profile" */ "../pages/Barcode.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue'),
        // NotificationBar: () => import(/* webpackChunkName: "NotificationBar" */ '../components/Layout/NotificationBar.vue'),
      },
    },
    // {
    //     path: '/consumption',
    //     meta: {
    //         requiresAuth: true
    //     },
    //     components: {
    //         default: () => import(/* webpackChunkName: "Consumption" */ '../pages/Consumption.vue'),
    //         // default: () => import(/* webpackChunkName: "Consumption" */ '../pages/PointPayment.vue'),
    //         // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
    //     }
    // },
    // {
    //     path: '/consumption-result',
    //     meta: {
    //         requiresAuth: true
    //     },
    //     components: {
    //         default: () => import(/* webpackChunkName: "ConsumptionResult" */ '../pages/ConsumptionResult.vue'),
    //         // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
    //     }
    // },
    {
      path: "/profile/edit",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ProfileEdit" */ "../pages/ProfileEdit.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/notification",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Notification" */ "../pages/Notification.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/notification-setting",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Notification" */ "../pages/NotificationSetting.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/parking-coupons",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ParkingCoupon" */ "../pages/ParkingCoupons.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/parking-coupons/detail/:id",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ParkingCoupon" */ "../pages/ParkingCouponsDetail.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/parking-coupons/confirm/:id",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ParkingCoupon" */ "../pages/ParkingCouponsConfirm.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ParkingCoupon" */ "../pages/DigitalCard/index.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/add",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/add.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/change",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/change.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/task",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/task.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/borrowing-list",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/borrowingList.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/reserve",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/reserve.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/digital-card/detail",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "DigitalCard" */ "../pages/DigitalCard/detail.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/volunteer",
      meta: {
        requiresAuth: true
      },
      components: {
        default: () => import("../pages/Volunteer.vue")
      }
    },
    {
      path: "/healthy-step",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "HealthyStep" */ "../pages/HealthyStep.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/merchant",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Merchant" */ "../pages/Merchant/index.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/merchant/permission/:id",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Merchant" */ "../pages/Merchant/permission.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/videos",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Campaign" */ "../pages/Videos.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/mini-games",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Campaign" */ "../pages/Games.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/campaign",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Campaign" */ "../pages/Campaign.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/campaign/:id/detail",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "QADetail" */ "../pages/QADetail.vue"
          ),
      },
      // }, {
      //     path: '/questions',
      //     meta: {
      //         requiresAuth: true
      //     },
      //     components: {
      //         default: () => import(/* webpackChunkName: "ActiveQuestions" */ '../pages/ActiveQuestions.vue'),
      //         Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      //     }
    },
    {
      path: "/campaign/:id/daily-sign",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "QADetail" */ "../pages/DailySign.vue"
          ),
      },
    },
    {
      path: "/campaign/:id/mini-game",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "QADetail" */ "../pages/WheelGame.vue"
          ),
      },
    },
    {
      path: "/campaign/:id/mini-game/reward",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "QADetail" */ "../pages/RewardDetail.vue"
          ),
      },
    },
    {
      path: "/articles",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Articles" */ "../pages/Articles.vue"),
      },
    },
    {
      path: "/articles/:id",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Article" */ "../pages/Article.vue"),
      },
    },
    {
      path: "/campaign-records",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "CampaignRecords" */ "../pages/CampaignRecords.vue"
          ),
      },
    },
    {
      path: "/stores",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Stores" */ "../pages/Stores.vue"),
        Footer: () =>
          import(
            /* webpackChunkName: "Footer" */ "../components/Layout/Footer.vue"
          ),
      },
    },
    {
      path: "/stores/:id/stamp-cards",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "StoreStamps" */ "../pages/StoreStampCards.vue"
          ),
      },
    },
    {
      path: "/stores/:id/info",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "StoreInfo" */ "../pages/StoreInfo.vue"),
      },
    },
    {
      path: "/stamp-cards",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "MyStampCards" */ "../pages/MyStampCards.vue"
          ),
      },
    },
    {
      path: "/stamp-cards/:id",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "StampCard" */ "../pages/StampCard.vue"),
      },
    },
    {
      path: "/carrier/edit",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "ProfileEdit" */ "../pages/CarrierEdit.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/websites",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Websites" */ "../pages/Websites.vue"),
      },
    },
    {
      path: "/profile/edit/phone",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Notification" */ "../pages/ProfileEditPhone.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B11",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Notification" */ "../pages/uide-B11.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/E2",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Notification" */ "../pages/uide-E2.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B1-2/:id",
      meta: {
        requiresAuth: false, // arnold-TODO
        //requiresAuth: false,
        publisher: "municipal",
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "QA" */ "../pages/QADetail.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B1",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Notification" */ "../pages/uide-B1.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B1-3/:id",
      meta: {
        requiresAuth: false,
        publisher: "municipal",
      },
      components: {
        default: () => import(/* webpackChunkName: "QA" */ "../pages/QA.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B1-1",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "Notification" */ "../pages/uide-B1-1.vue"
          ),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B2",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Notification" */ "../pages/uide-B2.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/B2-detail/:id",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Notification" */ "../pages/B2Detail.vue"),
        // Footer: () => import(/* webpackChunkName: "Footer" */ '../components/Layout/Footer.vue')
      },
    },
    {
      path: "/record-detail/:id",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "PaymentRecord" */ "../pages/RecordDetail.vue"
          ),
      },
    },
    {
      path: "/send",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Send" */ "../pages/Send.vue"),
      },
    },
    {
      path: "/ylid-validation",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Send" */ "../pages/YLIDValidation.vue"),
      },
    },
    {
      path: "/customer-service",
      meta: {
        requiresAuth: false,
      },
      components: {
        default: () =>
          import(
            /* webpackChunkName: "CustomerService" */ "../pages/CustomerService.vue"
          ),
      },
    },
    {
      path: "/setting",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "Setting" */ "../pages/Settings.vue"),
      },
    },
    {
      path: "/setting/delete-account",
      meta: {
        requiresAuth: true,
      },
      components: {
        default: () =>
          import(/* webpackChunkName: "SettingDeleteAccount" */ "../pages/Settings/DeleteAccount.vue"),
      },
    },
    {
      path: '/coin-rule',
      meta: {
        requiresAuth: true
      },
      components: {
        default: () => import(/* webpackChunkName: "Consumption" */ '../pages/CoinRule.vue')
      }
    },
    {
      path: '/E11',
      meta: {
        requiresAuth: true
      },
      components: {
        default: () => import(/* webpackChunkName: "Consumption" */ '../pages/E11.vue')
      }
    },
    {
      path: 'static',
      meta: {
        requiresAuth: true
      },
      components: {
        default: () => import(/* webpackChunkName: "Consumption" */ '../pages/Static.vue')
      }
    },
    {
      path: 'about',
      meta: {
        requiresAuth: false
      },
      components: {
        default: () => import(/* webpackChunkName: "About" */ '../pages/About.vue')
      }
    },
    {
      path: '/download',
      meta: {
        requiresAuth: false
      },
      components: {
        default: () => import(/* webpackChunkName: "Download" */ '../pages/Download.vue')
      }
    }
  ],
};
